import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./StudentWorkSpace.css";
import PromptBar from "./PromptBar";
import ChatHistoryItem from "../modules/Historical List/ChatHistoryItem";

const StudentWorkSpace = () => {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [search, setSearch] = useState("");
  const [errors, setErrors] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [aiResponse, setAiResponse] = useState('');
  const [chatMessages, setChatMessages] = useState([]);

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  // Simple spell/grammar check simulation
  const handleCheckGrammar = () => {
    const fakeErrors = [];
    if (text.includes("teh")) {
      fakeErrors.push({ word: "teh", suggestion: "the" });
    }
    if (text.includes("recieve")) {
      fakeErrors.push({ word: "recieve", suggestion: "receive" });
    }
    setErrors(fakeErrors);
  };

  // Search functionality
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // Download as PDF (simulated)
  const handleDownloadPDF = () => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: "application/pdf" });
    element.href = URL.createObjectURL(file);
    element.download = "StudentNotes.pdf";
    document.body.appendChild(element);
    element.click();
  };

  const goToWorkspace = () => {
    navigate("/StudentWorkSpace");
  };

  return (
    <div className="student-workspace">
      <h1 className="workspace-title">🎓 Student Workspace</h1>

      {/* Prompt Bar */}
      <div style={{ padding: '16px', background: '#f8f9fa' }}>
        <PromptBar
          onSearch={(query, results) => {
            console.log('Student Workspace search:', query, results);
            if (results && results.results && results.results.length > 0) {
              setSearchResults(results.results);
            }
          }}
          onAIResponse={(response) => {
            setAiResponse(response);
            setChatMessages(prev => [...prev, { type: 'ai', content: response, timestamp: new Date() }]);
          }}
          onSearchResults={(results) => {
            setSearchResults(results);
            setChatMessages(prev => [...prev, { type: 'search', content: results, timestamp: new Date() }]);
          }}
        />
      </div>

      {/* Chat Area */}
      <div className="chat-container">
        {chatMessages.map((message, idx) => (
          <div key={idx} className={`chat-message ${message.type}`}>
            {message.type === 'ai' && (
              <div className="ai-message">
                <div className="ai-avatar">🤖</div>
                <div className="ai-content">
                  <pre>{message.content}</pre>
                </div>
              </div>
            )}
            {message.type === 'search' && (
              <div className="search-message">
                <div className="search-avatar">🔍</div>
                <div className="search-content">
                  <h4>Search Results:</h4>
                  {message.content.map((result, resultIdx) => (
                    <div key={resultIdx} className="search-result-item">
                      <h5>
                        <a href={result.url} target="_blank" rel="noopener noreferrer">
                          {result.title}
                        </a>
                      </h5>
                      <p>{result.description}</p>
                      <small>{result.url}</small>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* PromptBar Layout with Historical Research and Summarize */}
      <div className="promptbar-layout">
        {/* Historical Research Section */}
        <div className="historical-research-section">
          <h4>📚 Historical Research</h4>
          <div className="historical-list">
            <ChatHistoryItem
              title="Essay Writing Tips"
              date="3 hours ago"
              onClick={() => console.log('Load essay writing history')}
            />
            <ChatHistoryItem
              title="Study Notes Summary"
              date="1 day ago"
              onClick={() => console.log('Load study notes history')}
            />
            <ChatHistoryItem
              title="Research Paper Help"
              date="2 days ago"
              onClick={() => console.log('Load research paper history')}
            />
            <ChatHistoryItem
              title="Grammar Corrections"
              date="1 week ago"
              onClick={() => console.log('Load grammar history')}
            />
          </div>
        </div>

        {/* Quick Summarize Section */}
        <div className="quick-summarize-section">
          <h4>⚡ Quick Summarize</h4>
          <div className="summarize-input-container">
            <textarea
              className="summarize-textarea"
              placeholder="Paste study material here to summarize..."
              rows="6"
            />
            <button className="summarize-button">Summarize</button>
          </div>
          <div className="summarize-response">
            <pre>Summary will appear here...</pre>
          </div>
        </div>
      </div>

      <div className="toolbar">
        <button onClick={handleCheckGrammar}>Check Grammar</button>
        <button onClick={handleDownloadPDF}>Download PDF</button>
        <button onClick={() => alert("Google Drive Integration Coming Soon!")}>
          Save to Drive
        </button>
      </div>

      <input
        type="text"
        placeholder="🔍 Search in text..."
        value={search}
        onChange={handleSearch}
        className="search-bar"
      />

      <textarea
        value={text}
        onChange={handleTextChange}
        placeholder="Start writing your notes..."
        className="text-editor"
      />

      {/* Search Results Display */}
      {searchResults && searchResults.length > 0 && (
        <div className="search-results-section">
          <h2>🔍 Search Results</h2>
          <div className="search-results">
            {searchResults.map((result, idx) => (
              <div key={idx} className="search-result-item">
                <h4>
                  <a href={result.url} target="_blank" rel="noopener noreferrer">
                    {result.title}
                  </a>
                </h4>
                <p>{result.description}</p>
                <small>{result.url}</small>
              </div>
            ))}
          </div>
        </div>
      )}

      {errors.length > 0 && (
        <div className="errors">
          <h3>Grammar Suggestions:</h3>
          <ul>
            {errors.map((err, i) => (
              <li key={i}>
                Replace <b>{err.word}</b> with <b>{err.suggestion}</b>
              </li>
            ))}
          </ul>
        </div>
      )}

      <button className="go-to-workspace-btn" onClick={goToWorkspace}>
        Go to Workspace
      </button>
    </div>
  );
};

export default StudentWorkSpace;
